import { normalizeVatIDValue } from './vat-id-normalize-value';
import { validateVatID } from './vat-id-validation';
export const vatIdViewer = {
    normalizeLoadedValue: normalizeVatIDValue,
    runAdditionalValidation: validateVatID
};

//# sourceMappingURL=definition-viewer.js.map